import { inject, Pipe, PipeTransform } from '@angular/core';
import { ChargePlan, ChargePlanData } from '../models/paywall-settings';
import { PaywallService } from '../services/paywall.service';
import { chargePlanDataForPlan } from '../helpers/quantity.helper';
import { richTextOrEmpty } from '../helpers/rich-text.helper';

@Pipe({
  name: 'chargePlanData'
})
export class ChargePlanDataPipe implements PipeTransform {
  paywallService: PaywallService = inject(PaywallService);

  transform(chargePlan: ChargePlan, property: keyof ChargePlanData): string {
    const data = chargePlanDataForPlan(chargePlan, this.paywallService.settings()?.chargePlanData);
    const value = data?.[property];
    if (Array.isArray(value)) {
      return richTextOrEmpty(value.filter(Boolean).join(''));
    }
    // A blank field is no copy, so the card does not render an empty heading.
    if (typeof value === 'string' && !value.trim()) {
      return '';
    }
    return (value ?? '') as string;
  }

}
